import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Gire_Title } from '../../../../../utils/ES/Modals/SocialModals';

const ModalSocialGire = () => {
  return (
    <>
      <ModalVideo
        id="gire-social"
        dataText={Gire_Title}
        videoSrc="https://player.vimeo.com/video/314075688?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_GIRE"
      />
    </>
  );
};

export default ModalSocialGire;
